'use client';

import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import Gradient_4_mob from '@images/gradients/gradient_4_mob.webp';
import Gradient_5 from '@images/gradients/gradient_5.webp';
import SVGrRight from '@images/renders/infrastructure_images/Default.svg';
import { scrollInfrastructure } from '@lib/tools/helpers/constants';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import classNames from 'classnames';
import NextImage from 'next/image';
import { useCallback, useEffect, useRef, useState } from 'react';
import SVG from 'react-inlinesvg';
import style from './HorizontalScrollInfra.module.scss';
function HorizontalScrollInfraInfra({
  isMobile
}) {
  const [translate, setTranslate] = useState(-150);
  const [rotateN, setRotaten] = useState(0);
  const [elWidth, setElWidth] = useState(0);
  const [maxOffset2, setMaxOffset2] = useState(0);
  const scrollRef = useRef(null);
  const activeRef = useRef(null);
  const wrapperRef = useRef(null);
  const wrapperNextRef = useRef(null);
  const wrapperPrevRef = useRef(null);
  const cursorNext = useRef(null);
  const cursorPrev = useRef(null);
  const goToLeft = () => {
    setTranslate(Math.max(-maxOffset2, translate - wrapperRef?.current?.getBoundingClientRect().width * 0.2));
  };
  const goToRight = () => {
    setTranslate(translate <= -maxOffset2 ? translate + wrapperRef?.current?.getBoundingClientRect().width * 0.2 : 0);
  };
  const moveCursor = useCallback((e, cursorRef) => {
    if (!cursorRef.current || !scrollRef.current) return;
    const containerRect = scrollRef.current.getBoundingClientRect();
    const x = e.clientX - containerRect.left;
    const y = e.clientY - containerRect.top;
    cursorRef.current.style.transform = `translate(${x - 68}px, ${y - 68}px)`;
  }, []);
  const showCursor = cursorRef_0 => {
    if (cursorRef_0.current) cursorRef_0.current.style.opacity = '1';
  };
  const hideCursor = cursorRef_1 => {
    if (cursorRef_1.current) cursorRef_1.current.style.opacity = '0';
  };
  useEffect(() => {
    const resizeHandler = () => {
      const windowElWidth = activeRef.current?.offsetWidth;
      setElWidth(windowElWidth);
    };
    resizeHandler();
  }, [elWidth]);
  useEffect(() => {
    if (wrapperRef.current) {
      const width = wrapperRef.current.getBoundingClientRect().width;
      const windowWidth = window.innerWidth;
      setMaxOffset2(width - windowWidth);
    }
  }, [wrapperRef.current]);
  useEffect(() => {
    if (wrapperRef) {
      setTranslate(-(wrapperRef.current?.getBoundingClientRect().width * 0.2));
    }
  }, [wrapperRef]);
  useEffect(() => {
    if (translate === -maxOffset2) {
      setRotaten(6);
    }
    if (translate === -(wrapperRef?.current?.getBoundingClientRect().width * 0.2)) {
      setRotaten(3);
    }
    if (translate === -maxOffset2 + wrapperRef?.current?.getBoundingClientRect().width * 0.2) {
      setRotaten(0);
    }
    if (translate >= 0) {
      setRotaten(-6);
    }
  }, [translate]);
  return <div className={classNames(style.horizontalScrollContainer, 'horizontal')} ref={scrollRef}>
      {scrollInfrastructure && <div className={style.horizontalScrollWrapper} style={{
      '--translate': `${translate}px`
    }} ref={wrapperRef}>
          {scrollInfrastructure.map(item => {
        return <div key={item.id} ref={activeRef} className={classNames(style.horizontalScrollItem, item.style)} style={{
          transform: item.rotate > 0 ? `rotate(${item.rotate + rotateN}deg)` : `rotate(${item.rotate - rotateN}deg)`,
          top: `${item.top}%`
        }}>
                <div className={style.itemInner}>
                  <ParallaxMedia onMove={true} src={item.src} src375={item.srcXS} className={style.horizontalScrollImg} />
                  <SafeHtmlRenderer tag='div' className={style.horizontalScrollImgTitle} content={item.text || ''} />
                </div>
                <NextImage loading='lazy' decoding='async' src={!isMobile ? Gradient_5 : Gradient_4_mob} alt='gradient' className={style.horizontalScrollImgGradient} />
              </div>;
      })}
        </div>}

      <button className={style.swiperButtonNext} ref={cursorNext}>
        <SVG src={SVGrRight.src} alt='SVGrRight' className={style.swiperButtonIconNext} />
      </button>

      <button className={style.swiperButtonPrev} ref={cursorPrev}>
        <SVG src={SVGrRight.src} alt='SVGrRight' className={style.swiperButtonIconPrev} />
      </button>

      <div className={style.buttonContainer}>
        <div className={classNames('buttonWrapperPrev', style.sliderButtons)} ref={wrapperPrevRef} onMouseEnter={() => showCursor(cursorPrev)} onMouseLeave={() => hideCursor(cursorPrev)} onMouseMove={e_0 => moveCursor(e_0, cursorPrev)} onClick={goToRight} role='button' tabIndex='0' />
        <div className={classNames('buttonWrapperNext', style.sliderButtons)} ref={wrapperNextRef} onMouseEnter={() => showCursor(cursorNext)} onMouseLeave={() => hideCursor(cursorNext)} onMouseMove={e_1 => moveCursor(e_1, cursorNext)} onClick={goToLeft} role='button' tabIndex='0' />
      </div>
    </div>;
}
export default HorizontalScrollInfraInfra;